import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';

const Footer = () => {
  return (
    <footer className="text-white" style={{ backgroundColor: '#18233F' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Footer Content */}
        <div className="py-16">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
            {/* Company Info */}
            <div className="col-span-1 lg:col-span-2">
              <div className="flex items-center mb-4">
                <img 
                  src="/assets/images/bluebglogo.jpeg"
                  alt="SendMyParcel"
                  className="h-20 w-auto"
                />
              </div>
              
              <p className="text-gray-300 mb-6 max-w-md leading-relaxed">
                India's leading multi-carrier shipping platform, offering competitive rates and reliable 
                delivery services for businesses and individuals across 190+ countries.
              </p>
              
              <div className="space-y-3">
                <div className="flex items-center space-x-3">
                  <MapPin className="h-4 w-4 text-[#F17221] flex-shrink-0" />
                  <span className="text-sm text-gray-300">
                    Madhuban Tower, A-200 Road no 4, Gali no 10, Mahipalpur, New Delhi 110037
                  </span>
                </div>
                <div className="flex items-center space-x-3">
                  <Phone className="h-4 w-4 text-[#F17221] flex-shrink-0" />
                  <span className="text-sm text-gray-300">
                    Phone: <a href="tel:01147501136" className="hover:text-[#F17221]">011-47501136</a>
                  </span>
                </div>
                <div className="flex items-center space-x-3">
                  <Phone className="h-4 w-4 text-[#F17221] flex-shrink-0" />
                  <span className="text-sm text-gray-300">
                    WhatsApp: <a href="https://wa.me/919821984141" className="hover:text-[#F17221]">9821984141</a>
                  </span>
                </div>
                <div className="flex items-center space-x-3">
                  <Mail className="h-4 w-4 text-[#F17221] flex-shrink-0" />
                  <span className="text-sm text-gray-300">
                    Email: <a href="mailto:contact@sendmyparcel.in" className="hover:text-[#F17221]">contact@sendmyparcel.in</a>
                  </span>
                </div>
              </div>
            </div>

            {/* Services */}
            <div>
              <p className="text-lg font-semibold mb-6">Services</p>
              <ul className="space-y-3">
                <li><a href="/international-shipping-india/" className="text-gray-300 hover:text-[#F17221] transition-colors text-sm">International Express</a></li>
                <li><a href="/ecommerce-shipping-solutions/" className="text-gray-300 hover:text-[#F17221] transition-colors text-sm">E-commerce Shipping</a></li>
                <li><a href="/shiprocket-alternative/" className="text-gray-300 hover:text-[#F17221] transition-colors text-sm">Shiprocket Alternative</a></li>
              </ul>
            </div>

            {/* Destinations */}
            <div>
              <p className="text-lg font-semibold mb-6">Destinations</p>
              <ul className="space-y-3">
                <li><a href="/send-courier-from-india-to-usa/" className="text-gray-300 hover:text-[#F17221] transition-colors text-sm">🇺🇸 India to USA</a></li>
                <li><a href="/send-courier-from-india-to-uk/" className="text-gray-300 hover:text-[#F17221] transition-colors text-sm">🇬🇧 India to UK</a></li>
                <li><a href="/send-courier-from-india-to-canada/" className="text-gray-300 hover:text-[#F17221] transition-colors text-sm">🇨🇦 India to Canada</a></li>
                <li><a href="/send-courier-from-india-to-australia/" className="text-gray-300 hover:text-[#F17221] transition-colors text-sm">🇦🇺 India to Australia</a></li>
                <li><a href="/send-courier-from-india-to-europe/" className="text-gray-300 hover:text-[#F17221] transition-colors text-sm">🇪🇺 India to Europe</a></li>
              </ul>
            </div>

            {/* Support */}
            <div>
              <p className="text-lg font-semibold mb-6">Support</p>
              <ul className="space-y-3">
                <li><a href="/track/" className="text-gray-300 hover:text-[#F17221] transition-colors text-sm">Track Shipment</a></li>
                <li><a href="/quote/" className="text-gray-300 hover:text-[#F17221] transition-colors text-sm">Get Quote</a></li>
                <li><a href="/support/" className="text-gray-300 hover:text-[#F17221] transition-colors text-sm">Customer Support</a></li>
                <li><a href="/shipping-rates-calculator/" className="text-gray-300 hover:text-[#F17221] transition-colors text-sm">Shipping Calculator</a></li>
                <li><a href="/blog/best-packaging-practices-international-ecommerce/" className="text-gray-300 hover:text-[#F17221] transition-colors text-sm">Packaging Guidelines</a></li>
                <li><a href="/blog/why-shipments-get-stuck-in-customs/" className="text-gray-300 hover:text-[#F17221] transition-colors text-sm">Customs Information</a></li>
                <li><a href="/blog/" className="text-gray-300 hover:text-[#F17221] transition-colors text-sm">Blog &amp; Shipping Tips</a></li>
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom Footer */}
        <div className="border-t border-gray-800 py-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="flex flex-col md:flex-row items-center space-y-2 md:space-y-0 md:space-x-6 text-sm text-gray-400">
              <p>&copy; 2026 Priority Connections Pvt Ltd. All rights reserved.</p>
              <div className="flex space-x-4">
                <a href="/privacy-policy/" className="hover:text-[#F17221] transition-colors">Privacy Policy</a>
                <a href="/terms-and-conditions/" className="hover:text-[#F17221] transition-colors">Terms of Service</a>
              </div>
            </div>
            
            {/* Social links hidden for now */}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;